module.exports = __webpack_public_path__ + "assets/img/icon-card.79f5dfaa.png";